class CandidateDirectoryState {
  pathForCandidate(candidate) {
    return `/recruiting/positions/${candidate.position.id}/funnel/${candidate.id}/${candidate.urlSlug}`;
  }
}

export default CandidateDirectoryState;
